import { ResolvedDropdown } from './ResolvedDropdown';

import { SeveritySelect } from './SeveritySelect';
import { ClearAllButton, Search } from '@cast/shared-search-ui';

import { Stack } from '@cast/design-system';

export const NotificationsFilters = () => {
  return (
    <Stack direction="row" gap="8px" mb="20px">
      <Stack flexGrow={1}>
        <Search placeholder="Search" searchWhileActive />
      </Stack>
      <Stack flexBasis="208px">
        <ResolvedDropdown />
      </Stack>
      <Stack flexBasis="228px">
        <SeveritySelect />
      </Stack>
      <Stack flexBasis="84px">
        <ClearAllButton sx={{ width: '100%' }} />
      </Stack>
    </Stack>
  );
};
